export const Marquee = ({ items, className = "" }) => (
  <div className={`marquee relative overflow-hidden border-y border-ink/10 bg-surface/70 py-6 ${className}`} aria-hidden="true">
    <div className="marquee-track flex w-max items-center gap-10 pr-10">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-10" aria-hidden={copy === 1}>
          {items.map((item, i) => (
            <span key={i} className="flex items-center gap-10">
              <span className="whitespace-nowrap font-display text-lg font-bold tracking-[0.15em] text-ink/45 sm:text-xl">{item}</span>
              <span className="inline-block h-1.5 w-1.5 shrink-0 rotate-45 bg-crimson" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
